import api from '../api'
import router, {pages} from '../../router'

export default {
    namespaced: true,
    state: {
        userInfo: {},
        menus: null,
        permissions: {// 权限
            osm_audit_waning_exception: false,// OSM-审计系统-报警与异常
            osm_audit_take_dou: false,// OSM-审计系统-提豆审核
            osm_audit_take_dou_complete: false,// OSM-审计系统-完全提豆检查
            osm_time_limit_no: false,// OSM-查询数据无时间限制
            osm_all_field: false,// OSM-信息全字段
            osm_room_info_export: false,// OSM-牌局信息导出
            osm_at_super_distribution: false,// AT分发全信息显示
        }
    },
    mutations: {
        setStateUserInfo(state, data) {
            state.userInfo = data;
            localStorage.setItem('token', data.token);
            localStorage.setItem('nickname', data.nickname);
            localStorage.setItem('authTypeCode', data.authTypeCode);
            localStorage.setItem('userId', data.userId);
        },
        setStateMenus(state, data) {

            newPages(pages[0], newKey(data, {}));

            function newKey(data, arr) {
                data.forEach(val => {
                    arr[val.url] = val;
                    if (val.childs.length > 0) {
                        arr[val.url].newChilds = {};
                        newKey(val.childs, arr[val.url].newChilds)
                    }
                });
                return arr
            }

            function newPages(p, arr) {
                p.children = p.children.filter(page => {
                    if (page.path in arr) {
                        page.meta.name = arr[page.path].name;
                        if (arr[page.path].newChilds) {
                            newPages(page, arr[page.path].newChilds);
                        }
                        return true
                    }
                });
                return p
            }

            router.addRoutes([...pages, {
                path: '*',
                redirect: '/login'
            }]);
            state.menus = pages[0].children;
        },
        setStatePermissions(state, info) {
            info.forEach(item => {
                state.permissions[item] = true
            });
        }
    },
    actions: {
        login({commit}, params) {
            return api.post('/authUsers/login', '登录', params).then(res => {
                if (res.code === 10016) {
                    return res
                } else {
                    commit('setStateUserInfo', res.data);
                    commit('setStateMenus', res.data.menus);
                    commit('setStatePermissions', res.data.dataPermissions);
                    router.replace('/')
                }
            })
        },
        sendSmsForRoot(store, params) {
            params.password = window.btoa(params.password);
            return api.post('/authUsers/sendSmsForRoot', '发送超级账号登录验证码', params)
        },
        logout() {
            return api.get('/authUsers/logout', '退出登录').then(() => {
                router.replace('/login');
                localStorage.clear();
                location.reload()
            })
        },
        getMenus({commit}) {
            if (!localStorage.getItem('token') || !localStorage.getItem('authTypeCode')) {
                localStorage.clear();
                router.replace('/login');
                return;
            }
            return api.get('/authUsers/menusAndDataCodes', '当前登录用户的菜单列表').then(res => {
                commit('setStateMenus', res.data.menus);
                commit('setStatePermissions', res.data.dataCodes);
            })
        }
    }
}